import { render } from "./FairBlackjack.vue?vue&type=template&id=ef88bfbc&scoped=true"
import script from "./FairBlackjack.vue?vue&type=script&lang=js"
export * from "./FairBlackjack.vue?vue&type=script&lang=js"

import "./FairBlackjack.vue?vue&type=style&index=0&id=ef88bfbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef88bfbc"]])

export default __exports__